import { findIndex, isBoolean } from 'lodash';
import { connect } from 'react-redux';
import { compose, withState, lifecycle, withHandlers, withProps } from 'recompose';

import inputs from './inputs';
import { t } from '../../../../../modules/infra/i18n';
import withToggle from '../../../../common/hoc/withToggle';
import withLoadingList from '../../../../common/hoc/withLoaingList';
import { showNotification } from '../../../../common/helpers/notifications';
import { fetchDuplicatesForCustomer, mergeDuplicates, withLoadingListActions, withOwner } from '../actions';

export default compose(
  connect(
    null,
    {
      fetchDuplicatesForCustomer: withLoadingListActions(fetchDuplicatesForCustomer),
      mergeDuplicates: withOwner(mergeDuplicates),
    },
  ),
  withToggle('modal', false),
  withState('survivingCustomer', 'setSurvivingCustomer', null),
  withState('duplicates', 'setDuplicates', []),
  withState('submitting', 'setSubmitting', false),
  withState('selectedIndices', 'setSelectedIndices', {}),
  withProps(() => ({ inputs: inputs() })),
  lifecycle({
    componentWillMount() {
      this.props.fetchDuplicatesForCustomer(
        this.props.survivingCustomerId,
        this.props.customerIds
      ).then((data) => {
        this.props.setSurvivingCustomer(data.survivingCustomer);
        this.props.setDuplicates(data.duplicates);

        const selectedIndices = Object.entries(this.props.inputs).reduce((memo, [key]) => ({
          ...memo,
          [key]: findIndex(data.duplicates, d => d[key] === data.survivingCustomer[key]),
        }), {});
        this.props.setSelectedIndices(selectedIndices);
      });
    },
  }),
  withHandlers({
    onCheckboxChange: props => (e) => {
      const { accessor, idx } = e.target.dataset;
      let { value } = e.target.dataset;
      if (isBoolean(props.survivingCustomer[accessor]) && !isBoolean(value)) {
        value = value === 'true';
      }
      const nextSurvivingCustomer = { ...props.survivingCustomer, [accessor]: value };
      if (props.inputs[accessor].onChange) {
        props.inputs[accessor].onChange(nextSurvivingCustomer, props.duplicates);
      }
      props.setSurvivingCustomer(nextSurvivingCustomer);

      const nextSelectedIndices = { ...props.selectedIndices, [accessor]: Number(idx) };
      props.setSelectedIndices(nextSelectedIndices);
    },
    selectAll: props => (e) => {
      const { idx } = e.target.dataset;
      const nextSurvivingCustomer = { ...props.survivingCustomer };
      const nextSelectedIndices = { ...props.selectedIndices };
      const duplicate = props.duplicates[idx];
      Object.entries(props.inputs).forEach(([, descriptor]) => {
        nextSurvivingCustomer[descriptor.accessor] = duplicate[descriptor.accessor];
        if (descriptor.onChange) {
          descriptor.onChange(nextSurvivingCustomer, props.duplicates);
        }
        nextSelectedIndices[descriptor.accessor] = Number(idx);
      });
      props.setSurvivingCustomer(nextSurvivingCustomer);
      props.setSelectedIndices(nextSelectedIndices);
    },
    submit: props => (e) => {
      e.preventDefault();
      props.setSubmitting(true);
      props.modalOff();

      const data = Object.entries(props.inputs).reduce((memo, [, descriptor]) => (
        { ...memo, [descriptor.accessor]: props.survivingCustomer[descriptor.accessor] }
      ), {});

      props.mergeDuplicates(
        props.survivingCustomerId,
        props.customerIds,
        data,
      ).then(() => {
        showNotification({
          title: t('customers:duplicates.merge_success_title'),
          level: 'success',
          message: t('customers:duplicates.merge_success_message'),
        });
        props.setSubmitting(false);
        props.resetSelectedForMerge();
      }).then(() => {
        props.setSubmitting(false);
      });
    },
    showModal: props => (e) => {
      e.preventDefault();
      props.modalOn();
    },
  }),
  withLoadingList(
    props => props.duplicates,
    () => null,
  ),
);
